module.exports = __webpack_public_path__ + "static/logo-meiquer-72606e65ccfae2d8a7a43745ac48a593.svg";